export enum TabId {
  DEFAULT = 2,
  LIST = 0,
  TABLE = 1,
  MAP = 2,
  LOCUS = 3,
  OBJECT = 4,
  HACHRAZA = 5
}